import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const createGroceryList = createAsyncThunk(
  "groceryList/createGroceryList",
  async (createGroceryList) => {
    const response = await axios.post(
      `${BASE_URL}/api/grocerylist`,
      createGroceryList
    );
    return response.data;
  }
);

export const emailGroceryList = createAsyncThunk(
  "groceryList/emailGroceryList",
  async (emailData) => {
    const response = await axios.post(
      `${BASE_URL}/api/emailgrocerylist`,
      emailData
    );
    return response.data;
  }
);

const groceryListSlice = createSlice({
  name: "groceryList",
  initialState: {
    groceryList: null,
    isLoading: false,
    isSending: false,
    error: null,
  },
  reducers: {
    clearGroceryList: (state) => {
      state.groceryList = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // create grocery list
      .addCase(createGroceryList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createGroceryList.fulfilled, (state, action) => {
        state.groceryList = action.payload;
        state.isLoading = false;
      })
      .addCase(createGroceryList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // email grocery list
      .addCase(emailGroceryList.pending, (state) => {
        state.isSending = true;
        state.error = null;
      })
      .addCase(emailGroceryList.fulfilled, (state, action) => {
        state.isSending = false;
      })
      .addCase(emailGroceryList.rejected, (state, action) => {
        state.isSending = false;
        state.error = action.error.message;
      });
  },
});

export const { clearGroceryList } = groceryListSlice.actions;

export default groceryListSlice.reducer;
